import React, { useState } from 'react'
import { AlertColor, Container, Typography, styled } from '@mui/material'
import { Navigate, useParams } from 'react-router-dom'
import Filter from '../../components/Filter'
import AdminHeader from '../../components/Headers/AdminHeader'
import LoadingScreen from '../../components/LoadingScreen'
import StyledSnackbar from '../../components/StyledSnackbar'
import AdminDashboardTable from '../../components/Table'
import { USER_TYPE } from '../../constants'
import { useGetFinancialDashboard } from '../../hooks/Admin/useAdminDashboard'
import { themes } from '../../theme'

type TYPE_PROPS = {
  title: string
  queryResult: any
  search: string
  status: string
  setSearch: (search: string, status: string) => void
  filteredData: {
    totalPage: number
    showCurrentPage: number
    currentData: any[]
  }
}

const FinancialDashBoard = () => {
  const [message] = useState('')
  const [severity] = useState<AlertColor | null>(null)
  const { financialType } = useParams()
  // @ts-ignore
  const type: TYPE_PROPS = useGetFinancialDashboard(financialType)
  if (!type) {
    return <Navigate to="/dashboard" replace />
  }
  const { search, status, setSearch, filteredData } = type
  const { isLoading: isUsersLoading, isFetching } = type.queryResult

  const items = filteredData?.currentData ?? []
  const onLoad = (search: string, status: string) => {
    setSearch(search, status)
  }

  return (
    <AdminHeader>
      <Container
        maxWidth={false}
        sx={{ backgroundColor: themes.light.background }}
      >
        {severity && (
          <StyledSnackbar
            isCenter
            severity={severity}
            message={message}
            open={true}
            setOpen={() => {}}
          />
        )}
        {isUsersLoading ? (
          <LoadingScreen />
        ) : (
          <React.Fragment>
            <Container
              disableGutters
              maxWidth="xl"
              component="main"
              sx={{ pl: 5, pr: 5, pb: 2, pt: 2 }}
            >
              <Title variant="h3" color="inherit" noWrap fontWeight="bold">
                {type.title}
              </Title>
            </Container>
            <Container
              disableGutters
              maxWidth="xl"
              component="main"
              sx={{ pl: 5, pr: 5, pb: 2 }}
            >
              {/* @ts-ignore */}
              <Filter
                isFetching={isFetching}
                onLoad={onLoad}
                search={search}
                status={status}
                admin
              />
            </Container>
            {/* Table Section */}
            <Container
              disableGutters
              maxWidth="xl"
              component="main"
              sx={{ pb: 20, pl: 5, pr: 5 }}
            >
              <AdminDashboardTable
                data={items}
                userType={USER_TYPE.FINANCIAL_DASHBOARD.TYPE}
                newPagination={filteredData}
                hidePagination
              />
            </Container>
            {/* Table Section */}
          </React.Fragment>
        )}
      </Container>
    </AdminHeader>
  )
}

export default FinancialDashBoard

const Title = styled(Typography)({
  color: themes.light.primary,
  flexGrow: 1,
})
